import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css';
import { getAge } from '_helpers';

class SpecialTestCervicalMyelopathyCPRAgeGT45 extends React.Component {

    componentDidMount() {
        if( this.props.ageGt45 === null && this.props.age > 45 ) {
            this.props.updateBitField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, 'TSCMYAGEGT45', true);

        }
    }

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Cervical Myelopathy CPR - Age > 45'/>
                <span className={styles.spacer} />
                <label className={styles.label}>Age &gt; 45 years old</label>
                <span className={styles.r} />
                <DBCheckBoxObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    field='TSCMYAGEGT45'
                    disabled={true}
                    className={styles.checkbox_center}
                />
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYAGEGT45 ? true : false,
        ageGt45: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYAGEGT45,
        age: getAge(state.entities.patients[state.ui.patients.selectedPtno].dob)
    };
}

const connectedSpecialTestCervicalMyelopathyCPRAgeGT45 = connect(mapStateToProps, mapDispatchToProps)(SpecialTestCervicalMyelopathyCPRAgeGT45);
export { connectedSpecialTestCervicalMyelopathyCPRAgeGT45 as SpecialTestCervicalMyelopathyCPRAgeGT45 };


